"use strict";

angular.module("core").constant(
    "IGNORED_MESSAGES", [
        "Failed to load resource",
        "Failed to load template",
        "Failed to execute 'pushState' on 'History'",
        "Failed to execute 'replaceState' on 'History'",
        "Script error",
        "iterations reached",
        "limit reached",
        "Maximum call stack size exceeded",
        "Converting circular structure to JSON",
        "ResizeObserver loop completed with undelivered notifications",
    ]
);



//////////////////
// WEBPACK FOOTER
// ./core/rollbar/rollbar.constant.js
// module id = 373
// module chunks = 0